import TamaraLogo from "./img/Tamara/tamara.png";
import TamaraPublicidad from "./img/Tamara/background.png";

import PoliPublicidad from "./img/Policlinica/background.jpeg";
import PoliclinicaLogo from "./img/Policlinica/logo.png";

import cedisaLogo from "./img/Cedisa/logoOrig.jpeg";
import cedisaPublicidad from "./img/Cedisa/publicidad.jpg";

import abreuLogo from "./img/Abreu/logo.png";
import abreuPublicidad from "./img/Abreu/publicidad.jpg";

import moderno from "./img/CMModerno/logo.png";
import modernoPublicidad from "./img/CMModerno/publicidad.jpeg";

import adLogo from "./img/AD/logo.png";
import adPublicidad from "./img/AD/publicidad.png";

import frayLogo from "./img/Fray Juan/logo.png";
import frayPublicidad from "./img/Fray Juan/publicidad.png";

import HigeaLogo from "./img/HIGEA/logo.png";
import HigeaPublicidad from "./img/HIGEA/publicidad.png";

import SantanaLogo from "./img/Santana/logo.png";
import SantanaPublicidad from "./img/Santana/publicidad.jpg";

import defaultImg from "./img/defaultImg.png";
import defaultPublicidad from "./img/publicidad.jpg";

import cadiLogo from "./img/CADI/logo.png";
import cadiPublicidad from "./img/CADI/publicidad.jpg";

import DrDLogo from "./img/DrD/logo.png";
import DrDPublicidad from "./img/DrD/publicidad.png";

import CMBOLogo from "./img/CMBO/CMBO_LOGO.png";
import CMBOPublicidad from "./img/CMBO/Publicidad_1.jpg";

import IDEMLogo from "./img/IDEM/logo.png";
import IDEMPublicidad from "./img/IDEM/publicidad.png";

import RADLogo from "./img/RADNET/logo.png";
import RADPublicidad from "./img/RADNET/publicidad.png";

import FALlogo from "./img/FundacionAL/Logo.png";
import FALPublicidad from "./img/FundacionAL/Publicidad.jpg";

import CELogo from "./img/CampoElías/logo.png";
import CEPublicidad from "./img/CampoElías/publicidad.jpg";

import IVITALESLogo from "./img/ImgVitales/logo.png";
import IVITALESPublicidad from "./img/ImgVitales/publicidad.png";

import UHELogo from "./img/UHE/logo.png";
import UHEPublicidad from "./img/UHE/publicidad.jpeg";

import SanRomanLogo from "./img/SanRoman/logo.png";
import SanRomanPublicidad from "./img/SanRoman/publicidad.png";

import CIELogo from "./img/CIE/logo.png";
import CIEPublicidad from "./img/CIE/publicidad.jpg";



const getConfiguration = (cliente = "CAMPO ELIAS", production = true, withHeaders = false) => {

  //Se llamada desde systemState.js
  cliente = cliente.toUpperCase();

  //URL de produccion. obtenemos protocolo, host y puerto, el puerto solo se agrega si existe
  const protocoloProduction =
    window.location.port && window.location.port !== "" && window.location.port !== "0" ? `:${window.location.port}` : "";
  const productionUrl = `${window.location.protocol}//${window.location.hostname}${protocoloProduction}`;

  const version = "v1.3.2.4";
  switch (cliente) {
    //Clientesx
    case "POLICLINICA":
      return {
        version: version,
        nombre: "Policlínica Metropolitana", //Titulo de dashboard
        logo: PoliclinicaLogo, //Logo de dashboard y login
        publicidad: PoliPublicidad, // Imagen de publicidad en dashboard
        showIdentificaciónBtn: false, // Login por tipo de credencial?
        url: production ? productionUrl : "http://www.policlinicametropolitana-apps.com:30080", //Servidor
        urlWebpage: "https://policlinicametropolitana.org", //Onclick de publicidad
        theme: "theme-yellow",
        verPublicidad: true,
        production: production,
        withHeaders: withHeaders,
        agendarCitas: false,
        facturacion: false,
        documentos:true,
        politicaTratamientoDatos: false,
        language: "en",
      };
    case "TAMARA":
      return {
        version: version,
        nombre: "Támara Imágenes Diagnósticas",
        logo: TamaraLogo,
        publicidad: TamaraPublicidad,
        showIdentificaciónBtn: true,
        url: production ? productionUrl : "https://tamara.cmr-apps.com",
        urlWebpage: "https://tamaraimagenes.com",
        theme: "theme-red",
        verPublicidad: true,
        production: production,
        withHeaders: withHeaders,
        agendarCitas: false,
        facturacion: false,
        documentos:true,
        politicaTratamientoDatos: false,
        language: "es",
      };
    case "CEDISA":
      return {
        version: version,
        nombre: "CEDISA",
        logo: cedisaLogo,
        verPublicidad: false,
        publicidad: cedisaPublicidad,
        showIdentificaciónBtn: false,
        url: production ? productionUrl : "https://portalresultados.cedisa.do",
        urlWebpage: "https://www.cedisa.do/index.php",
        theme: "theme-hardblue",
        production: production,
        withHeaders: withHeaders,
        agendarCitas: false,
        facturacion: false,
        documentos:true,
        politicaTratamientoDatos: false,
        language: "es",
        // http://www.cmr-apps.com
      };
    case "ABREU":
      return {
        version: version,
        nombre: "",
        logo: abreuLogo,
        publicidad: abreuPublicidad,
        showIdentificaciónBtn: false,
        url: production ? productionUrl : "http://190.167.197.220",
        urlWebpage: "https://www.clinicaabreu.com.do",
        theme: "theme-aqua",
        verPublicidad: true,
        production: production,
        withHeaders: withHeaders,
        agendarCitas: false,
        facturacion: false,
        documentos:true,
        politicaTratamientoDatos: false,
        language: "es",
        // http://www.cmr-apps.com
      };
    case "CMMODERNO":
      return {
        version: version,
        nombre: "Centro Medico Moderno",
        logo: moderno,
        publicidad: modernoPublicidad,
        showIdentificaciónBtn: false,
        url: production ? productionUrl : "http://190.167.197.220",
        urlWebpage: "https://cmm.do",
        theme: "theme-bluelight",
        verPublicidad: true,
        production: production,
        withHeaders: withHeaders,
        agendarCitas: false,
        facturacion: false,
        documentos:true,
        politicaTratamientoDatos: false,
        language: "es",
        // http://www.cmr-apps.com
      };
    case "AD":
      return {
        version: version,
        nombre: "Central de Especialidades Medicas AD",
        logo: adLogo,
        publicidad: adPublicidad,
        showIdentificaciónBtn: false,
        url: production ? productionUrl : "http://",
        urlWebpage: "https://asociadocs.com/",
        theme: "theme-blue",
        verPublicidad: true,
        production: production,
        withHeaders: withHeaders,
        agendarCitas: false,
        facturacion: false,
        documentos:true,
        politicaTratamientoDatos: false,
        language: "es",
        // http://www.cmr-apps.com
      };
    case "FRAY":
      return {
        version: version,
        nombre: "HOSPITAL Fray Juan De San Miguel",
        logo: frayLogo,
        publicidad: frayPublicidad,
        showIdentificaciónBtn: false,
        url: production ? productionUrl : "http://www.policlinicametropolitana-apps.com:30080",
        urlWebpage: "https://www.hospitalfrayjuan.com/sitio/",
        theme: "theme-blue",
        verPublicidad: true,
        production: production,
        withHeaders: withHeaders,
        agendarCitas: false,
        facturacion: false,
        documentos:true,
        politicaTratamientoDatos: false,
        language: "es",
        // http://www.cmr-apps.com
      };
    case "HIGEA":
      return {
        version: version,
        nombre: "CENTRO DIAGNÓSTICO HIGEA", //Titulo de dashboard
        logo: HigeaLogo, //Logo de dashboard y login
        publicidad: HigeaPublicidad, // Imagen de publicidad en dashboard
        showIdentificaciónBtn: false, // Login por tipo de credencial?
        url: production ? productionUrl : "http://200.76.159.141", //Servidor
        urlWebpage: "https://www.centrodiagnosticohigea.com/", //Onclick de publicidad
        theme: "theme-bluelight",
        verPublicidad: true,
        production: production,
        withHeaders: withHeaders,
        agendarCitas: false,
        facturacion: false,
        documentos:true,
        politicaTratamientoDatos: false,
        language: "es",
      };
    case "SANTANA":
      return {
        version: version,
        nombre: "Clínica Santa Ana de Dios", //Titulo de dashboard
        logo: SantanaLogo, //Logo de dashboard y login
        publicidad: SantanaPublicidad, // Imagen de publicidad en dashboard
        showIdentificaciónBtn: false, // Login por tipo de credencial?
        url: production ? productionUrl : "https://santaanadedios.cmr-apps.com:8050", //Servidor
        urlWebpage: "http://www.santaanadedios.com/", //Onclick de publicidad
        theme: "theme-santana",
        verPublicidad: true,
        production: production,
        withHeaders: withHeaders,
        agendarCitas: false,
        facturacion: false,
        documentos:true,
        politicaTratamientoDatos: false,
        language: "es",
      };
    case "CADI":
      return {
        version: version,
        nombre: "CADI",
        logo: cadiLogo,
        publicidad: cadiPublicidad,
        showIdentificaciónBtn: false,
        url: production ? productionUrl : "https://portal.cadi.do",
        urlWebpage: "https://www.cadi.do",
        theme: "theme-blue",
        verPublicidad: false,
        production: production,
        withHeaders: withHeaders,
        agendarCitas: true,
        facturacion: false,
        documentos:true,
        politicaTratamientoDatos: false,
        language: "es", 
      };
    case "DOC":
      return {
        version: version,
        nombre: "",
        logo: DrDLogo,
        publicidad: DrDPublicidad,
        showIdentificaciónBtn: false,
        url: production ? productionUrl : "https://drdiagnostico.cmr-apps.com",
        urlWebpage: " https://doctordiagnostico.com.mx/",
        theme: "theme-whiteblue",
        verPublicidad: true,
        production: production,
        withHeaders: withHeaders,
        agendarCitas: false,
        facturacion: false,
        documentos:true,
        politicaTratamientoDatos: false,
              language: "es", 
        // http://www.cmr-apps.com
      };
    case "CENTAURI":
      return {
        version: version,
        nombre: "",
        logo: DrDLogo,
        publicidad: DrDPublicidad,
        showIdentificaciónBtn: false,
        url: production ? productionUrl : "https://centauri.cmr-apps.com",
        urlWebpage: " https://doctordiagnostico.com.mx/",
        theme: "theme-whiteblue",
        verPublicidad: true,
        production: production,
        withHeaders: withHeaders,
        agendarCitas: false,
        facturacion: false,
        documentos:true,
        politicaTratamientoDatos: true,
        language: "es", 
        // http://www.cmr-apps.com
      };
    case "CMBO":
      return {
        version: version,
        nombre: "Centro Medico Bournigal",
        logo: CMBOLogo,
        publicidad: CMBOPublicidad,
        showIdentificaciónBtn: false,
        url: production ? productionUrl : "http://www.cmr-apps.com",
        urlWebpage: " https://doctordiagnostico.com.mx/",
        theme: "theme-greenwhitered",
        verPublicidad: true,
        production: production,
        withHeaders: withHeaders,
        agendarCitas: false,
        facturacion: false,
        documentos:true,
        politicaTratamientoDatos: false,
        language: "es", 
        // http://www.cmr-apps.com
      };
    case "IDEM":
      return {
        version: version,
        nombre: "Imágenes Diagnósticas de Especialidades Médicas",
        logo: IDEMLogo,
        publicidad: IDEMPublicidad,
        showIdentificaciónBtn: false,
        url: production ? productionUrl : "http://www.cmr-apps.com",
        urlWebpage: "",
        theme: "theme-bluemedium",
        verPublicidad: true,
        production: production,
        withHeaders: withHeaders,
        agendarCitas: false,
        facturacion: false,
        documentos:true,
        politicaTratamientoDatos: false,
        language: "es", 
        // http://www.cmr-apps.com
      };
    case "RADNET":
      return {
        version: version,
        nombre: "RADNET CENTRO DE IMÁGENES",
        logo: RADLogo,
        publicidad: RADPublicidad,
        showIdentificaciónBtn: false,
        url: production ? productionUrl : "http://www.cmr-apps.com",
        urlWebpage: "",
        theme: "theme-radgreen",
        verPublicidad: true,
        production: production,
        withHeaders: withHeaders,
        agendarCitas: false,
        facturacion: false,
        documentos:true,
        politicaTratamientoDatos: false,
        language: "es", 
        // http://www.cmr-apps.com
      };
    case "FUNDACION AL":
      return {
        version: version,
        nombre: "",
        logo: FALlogo,
        publicidad: FALPublicidad,
        showIdentificaciónBtn: false,
        url: production ? productionUrl : "https://demo.cmr-apps.com",
        urlWebpage: "https://fundacional.org",
        theme: "theme-fundacion",
        verPublicidad: true,
        production: production,
        withHeaders: withHeaders,
        agendarCitas: false,
        facturacion: false,
        documentos:true,
        politicaTratamientoDatos: true,
        language: "es", 
        // http://www.cmr-apps.com
      };
    case "CAMPO ELIAS":
      return {
        version: version,
        nombre: "",
        logo: CELogo,
        publicidad: CEPublicidad,
        howIdentificaciónBtn: false,
        url: production ? productionUrl : "https://demo.cmr-apps.com",
        urlWebpage: "",
        theme: "theme-campoelias",
        verPublicidad: true,
        production: production,
        withHeaders: withHeaders,
        agendarCitas: false,
        facturacion: false,
        documentos:false,
        politicaTratamientoDatos: true,
        language: "es", 
          // http://www.cmr-apps.com
      };
    
    case "UHE":
      return {
        version: version,
        nombre: "",
        logo: UHELogo,
        publicidad: UHEPublicidad,
        howIdentificaciónBtn: false,
        url: production ? productionUrl : "https://sirius.cmr-apps.com",
        urlWebpage: "",
        theme: "theme-uhe",
        verPublicidad: true,
        production: production,
        withHeaders: withHeaders,
        agendarCitas: false,
        facturacion: false,
        documentos: true,
        politicaTratamientoDatos: false,
        language: "es", 
          // http://www.cmr-apps.com
      };

    case "CIE":
        return {
          version: version,
          nombre: "",
          logo: CIELogo,
          publicidad: CIEPublicidad,
          showIdentificaciónBtn: false,
          url: production ? productionUrl : "https://sirius.cmr-apps.com",
          urlWebpage: "",
          theme: "theme-cie",
          verPublicidad: true,
          production: production,
          withHeaders: withHeaders,
          agendarCitas: false,
          facturacion: false,
          documentos: false,
          politicaTratamientoDatos: false,
          language: "es", 
        };

    default:
      return {
        version: version,
        nombre: "",
        logo: defaultImg,
        publicidad: defaultPublicidad,
        showIdentificaciónBtn: false,
        //url: productionUrl,
        urlWebpage: "https://www.cmr-rx.com",
        theme: "theme-blue",
        //LOCAL TEST
        //url: production ? "" :"http://www.cmr-apps.com",
        url: production ? productionUrl : "http://www.cmr-apps.com",
        verPublicidad: true,
        withHeaders: withHeaders,
        agendarCitas: true,
        facturacion: false,
        documentos:true,
        politicaTratamientoDatos: false,
        language: "es", 
      };
  }

}
export default getConfiguration;
